import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import { useHistory, useLocation } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Link from "@mui/material/Link";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import MuiPaper from "@mui/material/Paper";

import * as Yup from "yup";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ClearIcon from "@mui/icons-material/Clear";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";
import Modal from "../../components/Modal";

import FormHelperText from '@mui/material/FormHelperText';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ScheduleSendOutlinedIcon from '@mui/icons-material/ScheduleSendOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import "./Login.css";
import logo from "../../assets/images/erColor.png";
import api from "../../service/api";
import {
  login,
  setUsuario,
  setMenu,
  setAcciones,
} from "../../reducers/authSlice";


const Row = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const Form = styled("form")(({ theme }) => ({
  width: "100%", // Fix IE 11 issue.
}));

const Paper = styled(MuiPaper)(({ theme }) => ({
  padding: theme.spacing(5, 5, 5, 5),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  border: "1px solid #e0e0e0",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(5, 1, 5, 1),
  },
}));

const FormBox = styled(Box)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

const Error = styled(Box)(({ theme }) => ({
  backgroundColor: "#fadddd",
  color: "#772b35",
  borderColor: "#f8cfcf",
  borderRadius: ".25rem",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  textAlign: "center",
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

const Correcto = styled(Box)(({ theme }) => ({
  backgroundColor: "#ddfae0",
  color: "#ddfae0",
  borderColor: "#ddfae0",
  borderRadius: ".25rem",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  textAlign: "center",
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

const validationSchema = Yup.object().shape({
  documentoNuevo: Yup.string()
    .min(6, 'Minimo 6 dígitos')
    .max(8, 'Máximo 8 dígitos')
    .required('Requerido'),
  apellido: Yup.string()
    .min(2, 'Minimo 2 dígitos')
    .max(200, 'Máximo 200 dígitos')
    .required('Requerido'),
  nombre: Yup.string()
    .min(3, 'Minimo 3 dígitos')
    .max(200, 'Máximo 200 dígitos')
    .required('Requerido'),
  fecha_nacimiento: Yup.date()
    .typeError("Formato no válido")
    .required('Requerido')
    .max(new Date(Date.now() - 567648000000), "Debe ser mayor de edad") 
    .min("01/01/1900", "Fecha incorrecta"),
  domicilio_real: Yup.string()
    .max(200, 'Máximo 200 dígitos')
    .required('Requerido'),
  localidad_reside: Yup.string()
    .required('Requerido'),
  telefono: Yup.string()
    .min(9, 'Minimo 9 dígitos')
    .max(15, 'Máximo 15 dígitos')
    .required('Requerido'),
  email: Yup.string()
    .email('E-mail incorrecto')
    .required('Requerido'),
  reingresoMail: Yup.string()
    .email('E-mail incorrecto')
    .required('Requerido')
    .oneOf([Yup.ref("email"), null], "Las direcciones de correo deben coincidir"),
  direccion_administracion: Yup.string()
    .required('Requerido'),
  cod_planta: Yup.string()
    .required('Requerido'),
  formacion_id: Yup.string()
    .required('Requerido'),
  estado_formacion: Yup.string()
    .required('Requerido'),
  dependencia: Yup.string()
    .max(200, 'Máximo 200 dígitos')
    .required('Requerido'),
  localidad_trabaja: Yup.string()
    .required('Requerido'),
  passwordNueva: Yup.string()
    .min(6, 'Minimo 6 dígitos')
    .max(200, 'Máximo 200 dígitos')
    .required('Requerido'),
  reingresarPasswordNueva: Yup.string()
    .min(6, 'Minimo 6 dígitos')
    .max(200, 'Máximo 200 dígitos')
    .required('Requerido')
    .oneOf([Yup.ref("passwordNueva"), null], "Las contraseñas deben coincidir"),
});

const validationSchema2 = Yup.object().shape({
  usuarioRestablecer: Yup.string()
    .min(6, 'Minimo 6 dígitos')
    .max(8, 'Máximo 8 dígitos')
    .required('Requerido')
});

const validationSchema3 = Yup.object().shape({
  codigoValidacion: Yup.string()
    .min(6, 'Minimo 6 dígitos')
    .max(8, 'Máximo 8 dígitos')
    .required('Requerido'),
  passwordNuevaReestablecer: Yup.string()
    .min(6, 'Minimo 6 dígitos')
    .max(200, 'Máximo 200 dígitos')
    .required('Requerido'),
  reingresarPasswordNuevaReestablecer: Yup.string()
    .min(6, 'Minimo 6 dígitos')
    .max(200, 'Máximo 200 dígitos')
    .required('Requerido')
    .oneOf([Yup.ref("passwordNuevaReestablecer"), null], "Las contraseñas deben coincidir"),
});


const Login = (props) => {
  const captcha = useRef(null);
  const captcha2 = useRef(null);
  const captcha3 = useRef(null);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState("");
  const [documento, setDocumento] = useState("");
  const [contrasenia, setContrasenia] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitting2, setSubmitting2] = useState(false);
  const [submitting3, setSubmitting3] = useState(false);
  const [submitting4, setSubmitting4] = useState(false);
  const [submitting5, setSubmitting5] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [datosPlanta, setDatosPlanta] = useState([]);
  const [datosLocalidad, setDatosLocalidad] = useState([]);
  const [datosDireccionAdministracion, setDatosDireccionAdministracion] = useState([]);
  const [usuarioNuevo, setUsuarioNuevo] = useState("");
  const [tipoMensaje, setTipoMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [checkedProvincial, setCheckedProvincial] = useState(false);
  const [checkedMunicipal, setCheckedMunicipal] = useState(false);
  const [datosFormacionAcademica, setDatosFormacionAcademica] = useState([]);
  const [datosEstadoFormacionAcademica, setDatosEstadoFormacionAcademica] = useState([]);
  const [ocultarCodigo, setOcultarCodigo] = useState(true);
  const [usuarioValidado, setUsuarioValidado] = useState("");
  const [mailOfuscado, setMailOfuscado] = useState("");


  //*************  REGISTRARSE ***********/
  const [showRegistrarse, setShowRegistrarse] = useState(false);

  const cerrarRegistrarse = () => {
    formik.resetForm();
    setSubmitting2(false);
    setError("");
    setTipoMensaje("");
    setMensaje("");
    setShowRegistrarse(false);
  }

  const [showOlvido, setShowOlvido] = useState(false);

  const cerrarOlvido = () => {
    formik2.resetForm();
    formik3.resetForm();
    setSubmitting3(false);
    setSubmitting4(true);
    setMensaje('');
    setError('');
    setShowOlvido(false);
  }


  //para mostrar fecha actual en campo fecha de nacimiento

  let hoy = new Date();
  let mes;
  let dia;

  if ((hoy.getMonth() + 1) < 10) {
    mes = hoy.getMonth() + 1
    mes = '0' + mes
  } else {
    mes = hoy.getMonth() + 1
  }

  if ((hoy.getDate() + 1) < 10) {
    dia = hoy.getDate()
    dia = '0' + dia
  } else {
    dia = hoy.getDate()
  }

  let fechaActual = hoy.getFullYear() + '-' + mes + '-' + dia;

  const salt = process.env.REACT_APP_LS_SALT;

  const { from } = location.state || { from: { pathname: "/" } };

  const handleChangeTextField = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik.setFieldValue(event.target.id, event.target.value);
    }
  };

  const handleChangeTextField2 = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik2.setFieldValue(event.target.id, event.target.value);
      formik3.resetForm();
      setOcultarCodigo(true);
    }
  };

  const handleChangeTextField3 = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik3.setFieldValue(event.target.id, event.target.value);
    }
  };

  const loginUser = (
    nombreUsuario,
    menu,
    acciones,
    accessToken,
    refreshToken
  ) => {
    localStorage.setItem("usuario" + salt, nombreUsuario);
    localStorage.setItem("accessToken" + salt, accessToken);
    localStorage.setItem("refreshToken" + salt, refreshToken);
    dispatch(setUsuario(nombreUsuario));
    dispatch(setMenu(menu));
    dispatch(setAcciones(acciones));
    dispatch(login());
    //history.push(from);
    const location = {
      pathname: '/alumno/cursosDisponibles',
      //state: { fromDashboard: true }
    }
    history.push(location);
  };

  const handleOnChange = (event) => {
    setError("");
    switch (event.target.name) {
      case "documento":
        setDocumento(event.target.value);
        break;
      case "contrasenia":
        setContrasenia(event.target.value);
        break;
      default:
        break;
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

 const validate = () => {
      let validationError = "";
      if (documento.length === 0 && contrasenia.length === 0) {
        validationError = "Ingresá tu DNI y contraseña";
      } else if (documento.length === 0) {
        validationError = "Ingresá tu DNI";
      } else if (contrasenia.length === 0) {
        validationError = "Ingresá tu contraseña";
      } else if (!/^-?\d+$/.test(documento)) {
        validationError = "DNI: Solo números";
      } else if (contrasenia.length < 6) {
        validationError = "Contraseña: Mínimo 6 caracteres";
      } else if (captcha.current.getValue() === "") {
        validationError = "Por favor tildá la opción \"No soy un robot\"";
      }

      if (validationError === "") {
        return true;
      } else {
        setError(validationError);
        return false;
      }
};

const handleSubmit = (event) => {
  event.preventDefault();
  if (!validate()) return;
  setError("");
  setSubmitting(true);
  handleLogin({ documento, contrasenia });  
};

const handleLogin = (credenciales) => {
    setError("");
    setSubmitting(true);
    api
      .login({
        usuario: credenciales.documento,
        contrasenia: credenciales.contrasenia,
        captcha: captcha.current.getValue()      
      })
      .then((res) => {     
        captcha.current.reset();
        setSubmitting(false);
        let nombreUsuario = res.data.apellido + ", " + res.data.nombre;
        loginUser(
          nombreUsuario,
          res.data.menu,
          res.data.acciones,
          res.data.accessToken,
          res.data.refreshToken
        );
      })
      .catch((e) => {
        console.log(e);
        captcha.current.reset();
        setSubmitting(false);
        setError(
          e.response.data.error
            ? e.response.data.error
            : "Error de validación. Compruebe los campos."
        );
      });
  };

  
  const mostrarRegistrarse = () => {
    setError("");
    setTipoMensaje("");
    setMensaje("");
    setShowRegistrarse(true);
  }

  const mostrarOlvido = () => {
    setError("");
    setTipoMensaje("");
    setMensaje("");
    setSubmitting3(false);
    setSubmitting4(false);
    setShowOlvido(true);
  }
  
  const validarNuevoUsuario = (event) => {
    setUsuarioNuevo(event.target.value);
  }
  
  const formik = useFormik({
    initialValues: {
      documentoNuevo: '',
      apellido: '',
      nombre: '',
      fecha_nacimiento: fechaActual,
      domicilio_real: '',
      localidad_reside: '',
      localidad_trabaja: '',
      telefono: '',
      email: '',
      reingresoMail: '',
      direccion_administracion: '',
      dependencia: '',
      cod_planta: '',
      estado_formacion: '',
      formacion_id: '',
      passwordNueva: '',
      reingresarPasswordNueva: ''
    },

    enableReinitialize: true,

    validationSchema: validationSchema,

    onSubmit: (values) => {
      if (captcha2.current.getValue() === "") {      
        setTipoMensaje("N");
        setMensaje('Por favor tildá la opción \"No soy un robot\"');
      } else {
        setTipoMensaje("");
        setMensaje("");
        setSubmitting2(true);
        let datos = {
          dni: values.documentoNuevo,
          apellido: values.apellido.toUpperCase(),
          nombre: values.nombre.toUpperCase(),
          fecha_nacimiento: values.fecha_nacimiento,
          domicilio_real: values.domicilio_real.toUpperCase(),
          localidad_reside: values.localidad_reside,
          localidad_trabaja: values.localidad_trabaja,
          telefono: values.telefono,
          email: values.email,
          direccion_administracion: values.direccion_administracion.toUpperCase(),
          dependencia: values.dependencia.toUpperCase(),
          formacion: values.formacion_id,
          estado_formacion: values.estado_formacion,
          cod_planta: values.cod_planta,
          hash: values.passwordNueva,
          captcha: captcha2.current.getValue() 
        };

        api
          .inscribirAPlan(datos)
          .then((res) => {
            captcha2.current.reset();           
            setTipoMensaje("S");
            setMensaje('¡Bienvenida/o! En el correo electrónico ingresado verificá la situación de tu inscripción.');
            setTimeout(() => {
              cerrarRegistrarse();
            }, 5000);
          })
          .catch((e) => {
            captcha2.current.reset();    
            setTipoMensaje("N");
            setMensaje(e.response.data.error);
            setTimeout(() => {
                setTipoMensaje("");
                setMensaje('');
                setSubmitting2(false);             
            }, 3000);
          });
      }
    },
    onReset: () => {

    },
  });



  const formik2 = useFormik({
    initialValues: {
      usuarioRestablecer: '',
    },

    enableReinitialize: true,
    validationSchema: validationSchema2,

    onSubmit: (values) => {
      setTipoMensaje("");
      setMensaje("");
      setSubmitting3(true);
      setSubmitting5(true);

      let datos = {
        usuario: values.usuarioRestablecer        
      };

      api
        .obtenerCodigo(datos)
        .then((res) => {   
            setUsuarioValidado(values.usuarioRestablecer);
            setMailOfuscado(res.data);     
            setOcultarCodigo(false);
            setTimeout(() => {            
              setSubmitting3(false);            
              setSubmitting5(false);
            }, 10000);          
        })
        .catch((e) => {         
          setTipoMensaje("N");
          setMensaje('Error al intentar enviar el código para reestablecer contraseña.');
        });
    },
    onReset: () => {

    },
  });


  const formik3 = useFormik({
    initialValues: {
      codigoValidacion: '',
      passwordNuevaReestablecer: '',
      reingresarPasswordNuevaReestablecer: ''
    },

    enableReinitialize: true,

    validationSchema: validationSchema3,

    onSubmit: (values) => {

      if (captcha3.current.getValue() === "") {      
        setTipoMensaje("N");
        setMensaje('Por favor tildá la opción \"No soy un robot\"');
      } else {
            setTipoMensaje("");
            setMensaje("");
            setSubmitting4(true);

            let datos = {
              usuario: usuarioValidado,
              hash_nuevo: values.passwordNuevaReestablecer,
              codigo: values.codigoValidacion,
              captcha: captcha3.current.getValue()      
            };
        
            api
              .reestablecerPass(datos)
              .then((res) => {
                captcha3.current.reset();     
                setTipoMensaje("S");
                setMensaje('Usuario restablecido con éxito. Podes ingresar al Plan de Capacitaciones con tu usuario y contraseña.');
                setTimeout(() => {
                  cerrarOlvido();
                }, 3000);
              })
        
              .catch((e) => {
                captcha3.current.reset();
                setTipoMensaje("N");
                setMensaje(e.response.data.error);       
                setTimeout(() => {            
                    setTipoMensaje("");
                    setMensaje("");
                    setSubmitting4(false);
                    formik3.setFieldValue('codigoValidacion',"");
                }, 3000);              
              });     
            }     
    },
    onReset: () => {
        setTipoMensaje("");
        setMensaje("");
        setSubmitting4(false);
        setSubmitting3(false);
    },
  });

  const reenviarCodigo = () => {
    setTipoMensaje("");
    setMensaje("");

    let datos = {
      usuario: usuarioValidado
    };

    api
      .obtenerCodigo(datos)
      .then((res) => {
        setTipoMensaje("S");
        setMensaje('Código enviado correctamente .');
        setTimeout(() => {
          setTipoMensaje("");
          setMensaje("");
        }, 5000);
      })
      .catch((e) => {
        setTipoMensaje("N");
        setMensaje(e.response.data.error);  
      });
  }


  const mostrarDireccionAdministracion = (value) => {
    switch (value) {
      case 1:
        setCheckedProvincial(true);
        setCheckedMunicipal(false);
        setDatosDireccionAdministracion([]);
        buscarDireccionAdministracion(1);
        break;
      case 2:
        setCheckedProvincial(false);
        setCheckedMunicipal(true);
        setDatosDireccionAdministracion([]);
        buscarDireccionAdministracion(2);
        break;
      default:
        setDatosDireccionAdministracion([]);
        setCheckedProvincial(false);
        setCheckedMunicipal(false);
    }
  }

  const buscarPlantas = () => {
    api
      .listaPlantas()
      .then((res) => {
        setDatosPlanta(res.data);
      })
      .catch((e) => {
        console.log("Error al cargar los datos de planta");
      });
  };

  const buscarLocalidades = () => {
    api
      .listaLocalidades()
      .then((res) => {
        setDatosLocalidad(res.data);
      })
      .catch((e) => {
        console.log("Error al cargar los datos de las localidades");
      });
  };

  const buscarFormacionAcademica = () => {
    api
      .listaFormacionAcademica()
      .then((res) => {
        setDatosFormacionAcademica(res.data);
      })
      .catch((e) => {
        console.log("Error al cargar los datos de formación académica");
      });
  };

  const buscarEstadoFormacionAcademica = () => {
    api
      .listaEstadoFormacionAcademica()
      .then((res) => {
        setDatosEstadoFormacionAcademica(res.data);
      })
      .catch((e) => {
        console.log("Error al cargar los datos de los estados de formación académica");
      });
  };

  const buscarDireccionAdministracion = (ambitoDa) => {
    api
      .listaDireccionAdministracion(ambitoDa)
      .then((res) => {
        setDatosDireccionAdministracion(res.data);
      })
      .catch((e) => {
        console.log("Error al cargar los datos de las direcciones de administración");
      });
  };

  useEffect(() => {
    buscarFormacionAcademica();
    buscarEstadoFormacionAcademica();
    buscarPlantas();
    buscarLocalidades();
  }, []);

    
  return (
    <>
      <CssBaseline />
      <Box className="login">
        <Container component="main" maxWidth="xl">
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            height="95vh"
          >
            <Grid container spacing={1} justifyContent="center">
              <Grid item lg={7} sm={12} xs={12}>
                <Paper elevation={0}>

                  <Box mb={1}>
                    <img src={logo} mb={2} alt="Logo" />
                  </Box>

                  <Box alignSelf="flex-start" sx={{ p: 1 }}>
                    <Typography component="h1" variant="h5">
                      {String(
                        process.env.REACT_APP_NOMBRE_SISTEMA
                      ).toUpperCase()}
                    </Typography>
                    <Typography sx={{ color: "#768192" }}>
                      {String(process.env.REACT_APP_SUBNOMBRE_SISTEMA)}
                    </Typography>
                  </Box>

                  <FormBox sx={{ width: "100%" }}>
                    <Form noValidate onSubmit={handleSubmit}>
                      <TextField
                        variant="outlined"
                        size="small"
                        margin="normal"
                        fullWidth
                        id="documento"
                        label="USUARIO"
                        name="documento"
                        autoFocus
                        onChange={handleOnChange}
                      />
                      <TextField
                        variant="outlined"
                        size="small"
                        margin="normal"
                        fullWidth
                        name="contrasenia"
                        label="CONTRASEÑA"
                        type={showPassword ? "text" : "password"}
                        id="contrasenia"
                        autoComplete="current-password"
                        onChange={handleOnChange}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                    <Visibility />
                                  )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box mt={2} mb={2}>
                        <div clasname="recaptcha text-center" align="center">
                          <ReCAPTCHA
                            ref={captcha}                           
                            sitekey="6LdsgSgbAAAAAPg_cxA1KmgM43Lx7Mwas19i6y2A"
                          />
                        </div>
                      </Box>
                      {error !== "" ? (
                        <Error>
                          <Typography component="p" variant="cuerpo">
                            {error}
                          </Typography>
                        </Error>
                      ) : (
                          ""
                        )}
                      <Button
                        type="submit"
                        fullWidth
                        variant="verde"
                        mb={2}
                        disabled={submitting}
                      >
                        {submitting ? "INGRESANDO..." : "INGRESAR"}
                      </Button>
                    </Form>
                  </FormBox>

                  <br></br><br></br>

                  <Grid container spacing={2}>
                    <Grid item lg={6} xs={12} align="center" variant="cuerpo" color="#000000">
                      Si aún no tenés usuario {' '}
                      <Link href="#" onClick={mostrarRegistrarse} color="#636f83">
                        <b>{'Inscribite aquí'}</b>
                      </Link>
                      
                    </Grid>
                    <Grid item lg={6} xs={12} align="center">
                      <Link href="#" onClick={mostrarOlvido} color="#636f83">
                        {'¿Olvidaste tu contraseña?'}
                      </Link>                     
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          <Box component="div" mb={1}>
            <Container maxWidth="xl" disableGutters>
              <Box display="flex" flexDirection="row" justifyContent="center">
                <Typography sx={{ fontSize: "13px" }}>
                  Desarrollado por{" "}
                  <Link
                    href="https://www.entrerios.gov.ar/dgrrhh"
                    sx={{ color: "#799F4F", fontSize: "13px" }}
                    target="_blank"
                  >
                    {"Dirección General de Recursos Humanos"}
                  </Link>
                </Typography>
              </Box>
            </Container>
          </Box>
        </Container>
      </Box>

      <Modal open={showRegistrarse} handleClose={cerrarRegistrarse}>
        <form
          id="formDatosPersonales"
          name="formDatosPersonales"
          onSubmit={formik.handleSubmit}
          onReset={formik.handleReset}
          noValidate
          autoComplete="off"
        >
          <Grid container justifyContent="space-between" spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <Typography variant="titulo">
                REGISTRATE AL PLAN DE CAPACITACIONES DE LA ADMINISTRACIÓN PÚBLICA
                </Typography>
            </Grid>
            <br></br><br></br>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <Typography variant="cuerpo">
                <b>Ingresá tus datos y registrate en el Plan de Capacitaciones.</b>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
              <Typography variant="cuerpo">
                Te recomendamos que comiences por tus datos personales, luego selecciones y completes el resto de la información solicitada
                <br></br>(laborales, usuario y contraseña).
                <br></br>Una vez finalizada la carga de datos presionas el botón registrarse y listo podés ingresar al Plan de Capacitaciones de Entre Ríos
                <br></br>con tu usuario (número de documento) y la contraseña seleccionada.
              </Typography>
            </Grid>
          </Grid>
          <br></br><br></br>
          <Grid spacing={1}>
            <Grid>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="cuerpo"><b>DATOS PERSONALES</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Row container spacing={1}>
                    <Grid item lg={6} xs={12}>
                      <TextField
                        id="documentoNuevo"
                        name="documentoNuevo"
                        label="DOCUMENTO"
                        variant="outlined"
                        size="small"
                        fullWidth
                        onBlur={validarNuevoUsuario}
                        value={formik.values.documentoNuevo}
                        error={
                          formik.touched.documentoNuevo &&
                          Boolean(formik.errors.documentoNuevo)
                        }
                        helperText={
                          formik.touched.documentoNuevo &&
                          formik.errors.documentoNuevo
                        }
                        onChange={handleChangeTextField}
                      />
                    </Grid>
                  </Row>
                  <Row container spacing={1}>
                    <Grid item lg={6} xs={12}>
                      <TextField
                        id="apellido"
                        name="apellido"
                        label="APELLIDO"
                        variant="outlined"
                        size="small"
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                        value={formik.values.apellido.toUpperCase()}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.apellido &&
                          Boolean(formik.errors.apellido)
                        }
                        helperText={
                          formik.touched.apellido &&
                          formik.errors.apellido
                        }
                      />
                    </Grid>

                    <Grid item lg={6} xs={12}>
                      <TextField
                        id="nombre"
                        name="nombre"
                        label="NOMBRE"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={formik.values.nombre.toUpperCase()}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.nombre &&
                          Boolean(formik.errors.nombre)
                        }
                        helperText={
                          formik.touched.nombre &&
                          formik.errors.nombre
                        }
                      />
                    </Grid>
                  </Row>

                  <Row container spacing={1}>
                    <Grid item lg={3} xs={12}>
                      <TextField
                        id="fecha_nacimiento"
                        name="fecha_nacimiento"
                        label="FECHA DE NACIMIENTO"
                        variant="outlined"
                        size="small"
                        type="date"
                        onChange={formik.handleChange}
                        fullWidth
                        value={formik.values.fecha_nacimiento}
                        error={
                          formik.touched.fecha_nacimiento &&
                          Boolean(formik.errors.fecha_nacimiento)
                        }
                        helperText={
                          formik.touched.fecha_nacimiento &&
                          formik.errors.fecha_nacimiento
                        }
                      />
                    </Grid>
                  </Row>

                  <Row container spacing={1}>
                    <Grid item lg={8} xs={12}>
                      <TextField
                        id="domicilio_real"
                        name="domicilio_real"
                        label="DOMICILIO REAL"
                        variant="outlined"
                        size="small"
                        fullWidth
                        onChange={formik.handleChange}
                        value={formik.values.domicilio_real.toUpperCase()}
                        error={
                          formik.touched.domicilio_real &&
                          Boolean(formik.errors.domicilio_real)
                        }
                        helperText={
                          formik.touched.domicilio_real &&
                          formik.errors.domicilio_real
                        }
                      />
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <FormControl
                        variant="outlined"
                        size="small"
                        error={
                          formik.touched.localidad_reside && Boolean(formik.errors.localidad_reside)
                        }
                        fullWidth
                      >
                        <InputLabel id="soporteLabel">LOCALIDAD</InputLabel>
                        <Select
                          labelId="localidad_resideLabel"
                          id="localidad_reside"
                          name="localidad_reside"
                          variant="outlined"
                          label="LOCALIDAD"
                          onChange={formik.handleChange}
                          value={formik.values.localidad_reside}
                        >
                          {
                            datosLocalidad.map(itemLocalidad => (
                              <MenuItem key={itemLocalidad.id_localidad} value={itemLocalidad.id_localidad}> {itemLocalidad.desc_localidad.toUpperCase()}</MenuItem>
                            ))
                          }
                        </Select>
                        <FormHelperText>
                          {formik.touched.localidad_reside && formik.errors.localidad_reside}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  </Row>

                  <Row container spacing={1}>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        id="telefono"
                        name="telefono"
                        label="NÚMERO CELULAR"
                        variant="outlined"
                        size="small"
                        fullWidth
                        onChange={handleChangeTextField}
                        value={formik.values.telefono}
                        error={
                          formik.touched.telefono &&
                          Boolean(formik.errors.telefono)
                        }
                        helperText={
                          formik.touched.telefono &&
                          formik.errors.telefono
                        }
                      />
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        id="email"
                        name="email"
                        label="CORREO ELECTRÓNICO"
                        variant="outlined"
                        size="small"
                        fullWidth
                        //onBlur={validarMailUsuario}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.email &&
                          Boolean(formik.errors.email)
                        }
                        helperText={
                          formik.touched.email &&
                          formik.errors.email
                        }
                      />
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        id="reingresoMail"
                        name="reingresoMail"
                        label="REINGRESAR CORREO ELECTRÓNICO"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={formik.values.reingresoMail}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.reingresoMail &&
                          Boolean(formik.errors.reingresoMail)
                        }
                        helperText={
                          formik.touched.reingresoMail &&
                          formik.errors.reingresoMail
                        }
                      />
                    </Grid>
                  </Row>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3a-content"
                  id="panel3a-header"
                >
                  <Typography variant="cuerpo"><b>DATOS ACADÉMICOS</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Row container spacing={1}>
                    <Grid item lg={6} xs={12}>
                      <FormControl
                        variant="outlined"
                        size="small"
                        error={
                          formik.touched.formacion_id && Boolean(formik.errors.formacion_id)
                        }
                        fullWidth
                      >
                        <InputLabel id="soporteLabel">NIVEL ACADÉMICO</InputLabel>
                        <Select
                          labelId="formacion_idLabel"
                          id="formacion_id"
                          name="formacion_id"
                          variant="outlined"
                          label="NIVEL ACADÉMICO"
                          onChange={formik.handleChange}
                          value={formik.values.formacion_id}
                        >
                          {
                            datosFormacionAcademica.map(itemNivel => (
                              <MenuItem key={itemNivel.id} value={itemNivel.id}>{itemNivel.nombre.toUpperCase()}</MenuItem>
                            ))
                          }
                        </Select>
                        <FormHelperText>
                          {formik.touched.formacion_id && formik.errors.formacion_id}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item lg={6} xs={12}>
                      <FormControl
                        variant="outlined"
                        size="small"
                        error={
                          formik.touched.estado_formacion && Boolean(formik.errors.estado_formacion)
                        }
                        fullWidth
                      >
                        <InputLabel id="estado_formacionLabel">ESTADO DE NIVEL ACADÉMICO</InputLabel>
                        <Select
                          labelId="estado_formacionLabel"
                          id="estado_formacion"
                          name="estado_formacion"
                          variant="outlined"
                          label="ESTADO DE NIVEL ACADÉMICO"
                          onChange={formik.handleChange}
                          value={formik.values.estado_formacion}
                        >
                          {
                            datosEstadoFormacionAcademica.map(itemEstadoFormacion => (
                              <MenuItem key={itemEstadoFormacion.id} value={itemEstadoFormacion.id}> {itemEstadoFormacion.nombre.toUpperCase()}</MenuItem>
                            ))
                          }
                        </Select>
                        <FormHelperText>
                          {formik.touched.estado_formacion && formik.errors.estado_formacion}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  </Row>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography variant="cuerpo"><b>DATOS LABORABLES</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Row container spacing={3}>
                    <Grid item lg={12} xs={12} align="center">
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                        >
                          <FormControlLabel key="radioProvincial"
                            value="1"
                            control={<Radio />}
                            name="ambito"
                            id="provincial"
                            label="Trabajadores/as Provinciales   "
                            checked={checkedProvincial}
                            onChange={e => mostrarDireccionAdministracion(1)}
                          />
                          {'  '}
                          <FormControlLabel key="radioMunicipal"
                            value="2"
                            control={<Radio />}
                            name="ambito"
                            id="municipal"
                            label="Trabajadores/as de Gobiernos Locales"
                            checked={checkedMunicipal}
                            onChange={e => mostrarDireccionAdministracion(2)}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Row>

                  <Row container spacing={1}>
                    <Grid item lg={8} xs={12}>
                      <FormControl
                        variant="outlined"
                        size="small"
                        error={
                          formik.touched.direccion_administracion && Boolean(formik.errors.direccion_administracion)
                        }
                        fullWidth
                      >
                        <InputLabel id="soporteLabel">DIRECCIÓN DE ADMINISTRACIÓN</InputLabel>
                        <Select
                          labelId="direccion_administracionLabel"
                          id="direccion_administracion"
                          name="direccion_administracion"
                          variant="outlined"
                          label="DIRECCIÓN DE ADMINISTRACIÓN"
                          onChange={formik.handleChange}
                          value={formik.values.direccion_administracion}
                        >
                          {
                            datosDireccionAdministracion.map(itemDa => (
                              <MenuItem key={itemDa.id} value={itemDa.id}> {itemDa.da.toUpperCase()}</MenuItem>
                            ))
                          }
                        </Select>
                        <FormHelperText>
                          {formik.touched.direccion_administracion && formik.errors.direccion_administracion}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <FormControl
                        variant="outlined"
                        size="small"
                        error={
                          formik.touched.cod_planta && Boolean(formik.errors.cod_planta)
                        }
                        fullWidth
                      >
                        <InputLabel id="cod_plantaLabel">SITUACIÓN DE REVISTA</InputLabel>
                        <Select
                          labelId="cod_plantaLabel"
                          id="cod_planta"
                          name="cod_planta"
                          variant="outlined"
                          label="SITUACIÓN DE REVISTA"
                          value={formik.values.cod_planta}
                          onChange={formik.handleChange}
                        >
                          {
                            datosPlanta.map(itemPlanta => (
                              <MenuItem key={itemPlanta.cod_planta} value={itemPlanta.cod_planta}> {itemPlanta.desc_planta.toUpperCase()}</MenuItem>
                            ))
                          }
                        </Select>
                        <FormHelperText>
                          {formik.touched.cod_planta && formik.errors.cod_planta}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  </Row>

                  <Row container spacing={1}>
                    <Grid item lg={7} xs={12}>
                      <TextField
                        id="dependencia"
                        name="dependencia"
                        label="ORGANISMO DONDE PRESTA SERVICIO"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={formik.values.dependencia.toUpperCase()}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.dependencia &&
                          Boolean(formik.errors.dependencia)
                        }
                        helperText={
                          formik.touched.dependencia &&
                          formik.errors.dependencia
                        }
                      />
                    </Grid>
                    <Grid item lg={5} xs={12}>
                      <FormControl
                        variant="outlined"
                        size="small"
                        error={
                          formik.touched.localidad_trabaja && Boolean(formik.errors.localidad_trabaja)
                        }
                        fullWidth
                      >
                        <InputLabel id="localidad_trabajaLabel">LOCALIDAD DONDE TRABAJA</InputLabel>
                        <Select
                          labelId="localidad_trabajaLabel"
                          id="localidad_trabaja"
                          name="localidad_trabaja"
                          variant="outlined"
                          label="LOCALIDAD DONDE TRABAJA"
                          onChange={formik.handleChange}
                          value={formik.values.localidad_trabaja}
                        >
                          {
                            datosLocalidad.map(itemLocalidad => (
                              <MenuItem key={itemLocalidad.id_localidad} value={itemLocalidad.id_localidad}> {itemLocalidad.desc_localidad.toUpperCase()}</MenuItem>
                            ))
                          }
                        </Select>
                        <FormHelperText>
                          {formik.touched.localidad_trabaja && formik.errors.localidad_trabaja}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  </Row>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography variant="cuerpo"><b>USUARIO Y CONTRASEÑA</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Row container spacing={1}>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        id="usuarioNuevo"
                        name="usuarioNuevo"
                        label="USUARIO"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={usuarioNuevo}
                        error={
                          formik.touched.usuarioNuevo &&
                          Boolean(formik.errors.usuarioNuevo)
                        }
                        helperText={
                          formik.touched.usuarioNuevo &&
                          formik.errors.usuarioNuevo
                        }
                        disabled
                      />
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        id="passwordNueva"
                        name="passwordNueva"
                        label="CONTRASEÑA"
                        variant="outlined"
                        size="small"
                        type="password"
                        fullWidth
                        value={formik.values.passwordNueva}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.passwordNueva &&
                          Boolean(formik.errors.passwordNueva)
                        }
                        helperText={
                          formik.touched.passwordNueva &&
                          formik.errors.passwordNueva
                        }
                      />
                    </Grid>
                    <Grid item lg={4} xs={12}>
                      <TextField
                        id="reingresarPasswordNueva"
                        name="reingresarPasswordNueva"
                        label="REINGRESAR CONTRASEÑA"
                        variant="outlined"
                        size="small"
                        type="password"
                        fullWidth
                        value={formik.values.reingresarPasswordNueva}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.reingresarPasswordNueva &&
                          Boolean(formik.errors.reingresarPasswordNueva)
                        }
                        helperText={
                          formik.touched.reingresarPasswordNueva &&
                          formik.errors.reingresarPasswordNueva
                        }
                      />
                    </Grid>
                  </Row>
                </AccordionDetails>
              </Accordion>
            </Grid>

            {tipoMensaje === "" ? "" : (
              tipoMensaje === "S" ? (
                <Correcto>
                  <Typography component="p" variant="cuerpo">
                    {mensaje}
                  </Typography>
                </Correcto>
              ) : (
                  <Error>
                    <Typography component="p" variant="cuerpo">
                      {mensaje}
                    </Typography>
                  </Error>
                ))}

            <Box mt={2} mb={2}>
              <div clasname="recaptcha text-center" align="center">
                <ReCAPTCHA
                  ref={captcha2}
                  sitekey="6LdsgSgbAAAAAPg_cxA1KmgM43Lx7Mwas19i6y2A"
                />
              </div>
            </Box>

            <Grid
              item
              align="right"             
            >
              <Box align="right">
                <Button
                  variant="plata"
                  onClick={cerrarRegistrarse}
                  endIcon={<ClearIcon />}
                  sx={{ m: 1 }}
                >
                  {"Cancelar"}
                </Button>
                <Button
                  sx={{ m: 1 }}
                  variant="verde"
                  color="primary"
                  type="submit"
                  endIcon={<DoneOutlineRounded />}
                  disabled={submitting2}
                >
                  {submitting2 ? "REGISTRANDO..." : "REGISTRATE"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Modal>

      <Modal open={showOlvido} handleClose={cerrarOlvido}>
        <Grid container justifyContent="space-between" spacing={1}>
          <Grid item xs={12} sm={12} sx={{ marginBottom: 0 }}>
            <Typography variant="titulo">
              RESTABLECER CONTRASEÑA
                </Typography>
          </Grid>
        </Grid>
        <br></br><br></br>
        <form
          id="formOlvido"
          name="formOlvido"
          onSubmit={formik2.handleSubmit}
          onReset={formik2.handleReset}
          noValidate
          autoComplete="off"
        >
          <Grid container spacing={2}>
            <Grid item lg={12} xs={12} align="center">
              <Typography variant="cuerpo">
                <b>Ingresá tu usuario (Número de documento)</b>
              </Typography>
              {' '}
              <TextField
                id="usuarioRestablecer"
                name="usuarioRestablecer"
                label="USUARIO"
                variant="outlined"
                size="small"
                onChange={handleChangeTextField2}
                value={formik2.values.usuarioRestablecer}
                error={
                  formik2.touched.usuarioRestablecer &&
                  Boolean(formik2.errors.usuarioRestablecer)
                }
                helperText={
                  formik2.touched.usuarioRestablecer &&
                  formik2.errors.usuarioRestablecer
                }
              />
              {' '}
              <Button
                variant="verde"
                color="primary"
                type="submit"
                endIcon={<ScheduleSendOutlinedIcon />}
                disabled={submitting3}
              >
                {submitting3 ? "Enviar" : "Enviar"}
              </Button>
            </Grid>
          </Grid>

        </form>

        <br></br>
        <div id="codigoRegistro" hidden={ocultarCodigo}>
          <form
            id="formCodigo"
            name="formCodigo"
            onSubmit={formik3.handleSubmit}
            onReset={formik3.handleReset}
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={2}>
              <Grid item lg={12} xs={12} align="center">
                <Typography variant="cuerpo">
                  Al correo electrónico <b>{mailOfuscado}</b> se envió un código. <br></br>Ingresá ese código y la nueva contraseña.
              </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item lg={2} xs={12} align="center"></Grid>
              <Grid item lg={8} xs={12} align="center">
                <Box display="flex" flexDirection="row">
                  <TextField
                    id="codigoValidacion"
                    name="codigoValidacion"
                    label="CÓDIGO"
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={handleChangeTextField3}
                    value={formik3.values.codigoValidacion}
                    error={
                      formik3.touched.codigoValidacion &&
                      Boolean(formik3.errors.codigoValidacion)
                    }
                    helperText={
                      formik3.touched.codigoValidacion &&
                      formik3.errors.codigoValidacion
                    }
                  />
                  <IconButton
                    title={"Solicitar código nuevamente"}
                    onClick={reenviarCodigo}
                    disabled={submitting5}
                  >
                    <RestoreOutlinedIcon />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
            <br></br>
            <Grid container spacing={2}>
              <Grid item lg={2} xs={12} align="center"></Grid>
              <Grid item lg={8} xs={12} align="center">
                <TextField
                  id="passwordNuevaReestablecer"
                  name="passwordNuevaReestablecer"
                  label="CONTRASEÑA"
                  variant="outlined"
                  size="small"
                  fullWidth
                  type="password"
                  value={formik3.values.passwordNuevaReestablecer}
                  onChange={formik3.handleChange}
                  error={
                    formik3.touched.passwordNuevaReestablecer &&
                    Boolean(formik3.errors.passwordNuevaReestablecer)
                  }
                  helperText={
                    formik3.touched.passwordNuevaReestablecer &&
                    formik3.errors.passwordNuevaReestablecer
                  }
                />
              </Grid>
            </Grid>
            <br></br>
            <Grid container spacing={2}>
              <Grid item lg={2} xs={12} align="center"></Grid>
              <Grid item lg={8} xs={12} align="center">
                <TextField
                  id="reingresarPasswordNuevaReestablecer"
                  name="reingresarPasswordNuevaReestablecer"
                  label="REINGRESAR CONTRASEÑA"
                  variant="outlined"
                  size="small"
                  fullWidth
                  type="password"
                  value={formik3.values.reingresarPasswordNuevaReestablecer}
                  onChange={formik3.handleChange}
                  error={
                    formik3.touched.reingresarPasswordNuevaReestablecer &&
                    Boolean(formik3.errors.reingresarPasswordNuevaReestablecer)
                  }
                  helperText={
                    formik3.touched.reingresarPasswordNuevaReestablecer &&
                    formik3.errors.reingresarPasswordNuevaReestablecer
                  }
                />
              </Grid>
            </Grid>
            <br></br>
            <Box mt={2} mb={2}>
              <div clasname="recaptcha text-center" align="center">
                <ReCAPTCHA
                  ref={captcha3}
                  sitekey="6LdsgSgbAAAAAPg_cxA1KmgM43Lx7Mwas19i6y2A"
                />
              </div>
            </Box>
            <br></br>
            {tipoMensaje === "" ? "" : (
              tipoMensaje === "S" ? (
                <Correcto>
                  <Typography component="p" variant="cuerpo">
                    {mensaje}
                  </Typography>
                </Correcto>
              ) : (
                  <Error>
                    <Typography component="p" variant="cuerpo">
                      {mensaje}
                    </Typography>
                  </Error>
                ))}

            <Grid container spacing={2}>
              <Grid item lg={2} xs={12} align="center"></Grid>
              <Grid item lg={8} xs={12} align="center">
                <Button
                  variant="verde"
                  color="primary"
                  type="submit"
                  endIcon={<RestartAltOutlinedIcon />}
                  disabled={submitting4}
                  fullWidth
                >
                  {submitting4 ? "Restableciendo..." : "Reestablecer"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
        <Grid container spacing={2}>
          <Grid item lg={12} xs={12} align="right">
            <Button
              variant="plata"
              onClick={cerrarOlvido}
              endIcon={<ClearIcon />}
              sx={{ m: 1 }}
            >
              Cerrar
          </Button>
          </Grid>
        </Grid>
      </Modal >
    </>
  );
};

export default Login;